import { API_KEY, API_URL_WITHOUT_USER } from "../../Utils/API";
import { getDispatch, isLoadingAction } from "../../Utils/helper";
import { HttpUtil } from "../../Utils/http-utils";
import {
  GET_INSURER_APPOOINTMENT_DETAIL,
  GET_INSURER_PAYOUT_DETAIL,
  GET_PAYABLE_ACTION,
  GET_PAYOUT_INSURER_COUNT,
  GET_PAYOUT_STATUS,
  GET_STATUS_QUEUE_DATA,
  GET_TOTAL_BILLING,
  GET_TOTAL_CLIENT_DATA,
  GET_TOTAL_COUNT,
  getNetworkMenuId,
  getRole,
  getToken,
  INS_REMARKS,
} from "../../Utils/types";

export const GetInsurerPayoutCountsNetwork = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GetInsurerPayoutCountsNetwork`;
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    ApiKey: API_KEY,
    MenuId: getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_PAYOUT_INSURER_COUNT, res?.data?.results, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_PAYOUT_INSURER_COUNT, null, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const GetTotalAppointmentAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GetAppointmentInsurerPayoutDetailsNetwork`;
  isLoadingAction(true, dispatch);
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    ApiKey: API_KEY,
    MenuId: getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(
        GET_INSURER_APPOOINTMENT_DETAIL,
        res?.data?.results?.lstAppointmentPayoutDetails,
        dispatch
      );
      getDispatch(
        INS_REMARKS,
        res?.data?.results?.lstInsureRemarks,
        dispatch
      );
      getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_INSURER_APPOOINTMENT_DETAIL, null, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};
export const GetReceivablesDataAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GetInsurerGeneratedReceiveIdDetailsNetwork`;
  isLoadingAction(true, dispatch);
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    ApiKey: API_KEY,
    MenuId: getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_PAYABLE_ACTION,res?.data?.results?.lstPayIdDetails,dispatch)
      getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_PAYABLE_ACTION, null, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const GetPendingReceivables = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GetPendingReceivables`;
  isLoadingAction(true, dispatch);
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    ApiKey: API_KEY,
    MenuId: getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      console.log("GetPendingReceivables",res)
      getDispatch(GET_PAYABLE_ACTION,res?.data?.results?.lstpendingReceivable,dispatch)
      getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_PAYABLE_ACTION, null, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const GetPendingReceivablesDetails = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GetPendingReceivablesDetails`;
  isLoadingAction(true, dispatch);
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    ApiKey: API_KEY,
    MenuId: getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      console.log("GetPendingReceivablesDetails",res)
      getDispatch(GET_PAYABLE_ACTION,res?.data?.results?.lstpendingReceivable,dispatch)
      getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_PAYABLE_ACTION, null, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};


export const GetTotalBillingDataAction = (e) => (dispatch) => {
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GetInsurerMonthWisePayoutDetailsNetwork`;
  isLoadingAction(true, dispatch);
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    ApiKey: API_KEY,
    MenuId: getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(GET_TOTAL_BILLING, res?.data?.results, dispatch);
      getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_TOTAL_BILLING, null, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const GetTotalClientDataAction = (e) => (dispatch) => {
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GetInsurerBillingDetailsNetwork`;
  isLoadingAction(true, dispatch);
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    ApiKey: API_KEY,
    MenuId: getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(
        GET_TOTAL_CLIENT_DATA,
        res?.data?.results?.lstProviderPayoutDetails,
        dispatch
      );
      getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_TOTAL_CLIENT_DATA, null, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};
export const GetStatuQueueDataAction = (e) => (dispatch) => {
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GetOtherStatusAppointmentsDetailsNetwork`;
  isLoadingAction(true, dispatch);
  return HttpUtil.makePOST(url, e, {
    Authorization: getToken(),
    ApiKey: API_KEY,
    MenuId: getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(
        GET_STATUS_QUEUE_DATA,
        res?.data?.results?.lstAppointmentPayoutDetails,
        dispatch
      );
      getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_STATUS_QUEUE_DATA, null, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};

export const sendToQcAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/AddPayoutInsurerApprovalIBU`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  })
};




export const removeBillingAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/RemoveInsurerBilling`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    isLoadingAction(false, dispatch);
    return res
  });
};
export const MoveToBillingAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/MoveToBillingOtherStatusAppointment`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    isLoadingAction(false, dispatch);
    return res
  });
};
export const BillingAdjustmentAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/BillingAdjustment`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    isLoadingAction(false, dispatch);
    return res
  });
};
export const EditByFinanceAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/InsurerBillingEditByFinance`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    isLoadingAction(false, dispatch);
    return res
  });
};
export const GSTCalculation = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GSTCalculation`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    isLoadingAction(false, dispatch);
    return res
  });
};

export const GenerateInsurerUTRAction = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GenerateInsurerUTR`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  })
};
export const UpdateInvoiceAction = (inId,inDate,reId) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/UpdateInsertInsurerInvoiceDetails?InvoiceNumber=${inId}&InvoiceDate=${inDate}&receiveId=${reId}`;
  return HttpUtil.makePOST(url, {}, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  })
};

export const GenerateUnSuccessfulBilling = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GenerateUnSuccessfulBilling`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  })
};
export const EnabledForInsurer = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/EnabledForInsurer`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  })
};
export const EditInsurerRemarks = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/EditInsurerRemarks`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  })
};

export const GetInsurerDashboardDetails = (e) => (dispatch) => {
  isLoadingAction(true, dispatch);
  const url = `${API_URL_WITHOUT_USER}/NetworkPayout/GetInsurerDashboardDetails`;
  return HttpUtil.makePOST(url, e, {
    ApiKey: API_KEY,
    Authorization: getToken(),
    MenuId: getRole() === "NetworkAdmin" && getNetworkMenuId()?.menuId,
  }).then((res) => {
    if (res?.data?.status === true) {
      getDispatch(
        GET_INSURER_APPOOINTMENT_DETAIL,
        res?.data?.results?.lstAppointmentPayoutDetails,
        dispatch
      );
      getDispatch(GET_TOTAL_COUNT, res?.data?.results?.totalRow, dispatch);
      isLoadingAction(false, dispatch);
    } else {
      getDispatch(GET_INSURER_APPOOINTMENT_DETAIL, null, dispatch);
      isLoadingAction(false, dispatch);
    }
  });
};